import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  #jsd-widget { 
    transform: scale(0.8);
    z-index: 9998 !important;
  }
  
  .portal-team {
    #jsd-widget {
      left: 5px;
      visibility: hidden;
      right: unset !important;
      bottom: -5px !important;
    }

    &.side-bar-visible {
      #jsd-widget {
        visibility: visible;
      }
    }
  }
  
  .portal-hospital {
    #jsd-widget {
      visibility: hidden;
    }
    
    &.jsd-visible {
      #jsd-widget {
        visibility: visible;
      }
    }
  }

  .portal-pet-owner {
    #jsd-widget {
      visibility: hidden;
    }
    
    &.jsd-visible {
      #jsd-widget {
        visibility: visible;
      }
    }
  }
  
  .__floater__arrow {
    polygon {
      fill: ${({ theme }) => (theme as any).config.background};
    }
  }

  .pre-wrap {
    white-space: pre-wrap;
  }

  /* Fix Quill editor numbered list rendering issues - numbers being cut off */
  .ql-editor {
    /* Fix ordered lists - ensure proper spacing and no clipping */
    ol {
      margin: 0;
      /* Ensure enough space for two-digit numbers - increase padding significantly */
      /* Standard is usually 1.5em, but we need at least 2.8em for two-digit numbers */
      padding-left: 2.8em !important;
      list-style-position: outside;
      /* Add margin to prevent clipping at top */
      margin-top: 2px;
      margin-bottom: 2px;

      li {
        margin: 0;
        padding: 0;
        padding-left: 0.5em;
        /* Prevent text from being cut off vertically */
        padding-top: 2px;
        padding-bottom: 2px;
        line-height: 1.7;
        /* Ensure list markers are visible and not clipped */
        list-style-position: outside;
        /* Ensure proper display */
        display: list-item;
        /* Ensure content doesn't get cut - minimum height for proper rendering */
        min-height: 1.6em;
        /* Prevent any clipping */
        overflow: visible;
        position: relative;
      }
    }

    /* Ensure editor has proper padding to prevent content from being cut at edges */
    padding-top: 12px;
    padding-bottom: 12px;
  }
`;
